module.exports = __webpack_public_path__ + "img/CARAC2.8aa3b103.jpg";